const q=(s,c=document)=>c.querySelector(s);
const qa=(s,c=document)=>[...c.querySelectorAll(s)];
const body=document.body;
const cartRoot=window.Shopify?.routes?.root||'/';
const escapeCart=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
let cartQueue=Promise.resolve(),cartError=null;
const toast=q('[data-toast]');
let toastTimer;
function notify(message){if(!toast)return;toast.textContent=message;toast.classList.add('is-visible');clearTimeout(toastTimer);toastTimer=setTimeout(()=>toast.classList.remove('is-visible'),2800)}
function money(cents,currency='USD'){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency}).format(cents/100)}
function openLayer(el){if(!el)return;el.setAttribute('aria-hidden','false');el.classList.add('is-open');body.classList.add('no-scroll')}
function closeLayer(el){if(!el)return;el.setAttribute('aria-hidden','true');el.classList.remove('is-open');body.classList.remove('no-scroll')}
const cartDrawer=q('[data-cart-drawer]');


const mobile=q('[data-mobile-menu]');
qa('[data-open-menu]').forEach(b=>b.addEventListener('click',()=>openLayer(mobile)));
qa('[data-close-menu]').forEach(b=>b.addEventListener('click',()=>closeLayer(mobile)));
const search=q('[data-search-dialog]');
qa('[data-open-search]').forEach(b=>b.addEventListener('click',()=>{search.showModal();setTimeout(()=>q('input[type=search]',search)?.focus(),50)}));
qa('[data-close-search]').forEach(b=>b.addEventListener('click',()=>search.close()));
search?.addEventListener('click',e=>{if(e.target===search)search.close()});
async function refreshCart(open=true){return window.edviCart.refresh(open);}
qa('form[action*="/cart/add"]').forEach(form=>form.addEventListener('submit',async e=>{
  e.preventDefault();
  const button=q('[type=submit]',form);
  button.disabled=true;
  button.dataset.label=button.textContent;
  button.textContent=('Adding…');
  try{
    await window.EdviBag.add(new FormData(form));
    await refreshCart(true);
    notify(('Added to your bag.'))
  }catch(err){notify(err.message)}
  finally{button.disabled=false;button.textContent=button.dataset.label}
}));
qa('[data-product-root]').forEach(root=>{
  const data=q('[data-variants-json]',root);
  if(!data)return;
  const variants=JSON.parse(data.textContent);
  const selects=qa('[data-option-select]',root);
  const id=q('[name=id]',root);
  const price=q('[data-product-price]',root);
  const compare=q('[data-product-compare]',root);
  const add=q('[data-add-to-cart]',root);
  function update(){
    const chosen=selects.map(s=>s.value);
    const v=variants.find(x=>x.options.every((o,i)=>o===chosen[i]));
    if(!v)return;
    if(id)id.value=v.id;
    if(price)price.textContent=money(v.price);
    if(compare){compare.textContent=v.compare_at_price>v.price?money(v.compare_at_price):'';compare.hidden=!(v.compare_at_price>v.price)}
    if(add){add.disabled=!v.available;add.textContent=v.available?(add.dataset.availableLabel||('Add to bag')):(add.dataset.unavailableLabel||('Sold out'))}
    const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url)
  }
  selects.forEach(s=>s.addEventListener('change',update));
  update()
});
qa('[data-thumb]').forEach(b=>b.addEventListener('click',()=>{
  const main=q('[data-gallery-main]');
  if(!main)return;
  main.src=b.dataset.src;
  main.srcset='';
  qa('[data-thumb]').forEach(x=>x.classList.remove('is-active'));
  b.classList.add('is-active')
}));
let ticking=false;
addEventListener('scroll',()=>{
  if(ticking)return;
  ticking=true;
  requestAnimationFrame(()=>{
    const max=document.documentElement.scrollHeight-innerHeight;
    const p=max>0?scrollY/max:0;
    document.documentElement.style.setProperty('--scroll-progress',p);
    qa('[data-parallax]').forEach(el=>el.style.transform='translate3d(0,'+(scrollY*.07)+'px,0)');
    ticking=false
  })
},{passive:true});
const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('is-visible')}),{threshold:.08});
qa('[data-reveal]').forEach(el=>io.observe(el));
document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeLayer(mobile);if(search?.open)search.close()}});
